<!-- ── AI Act Art. 50 — First-session disclaimer modal ─────────────────── -->
<div class="chat-disclaimer-modal" *ngIf="showDisclaimerModal" role="dialog"
     aria-modal="true" aria-labelledby="disclaimer-title">
  <div class="chat-disclaimer-modal__box">
    <div class="chat-disclaimer-modal__icon">🤖</div>
    <h2 class="chat-disclaimer-modal__title" id="disclaimer-title">{{ 'chatAi.disclaimer.title' | translate }}</h2>
    <p class="chat-disclaimer-modal__body" [innerHTML]="'chatAi.disclaimer.body' | translate"></p>
    <p class="chat-disclaimer-modal__legal" [innerHTML]="'chatAi.disclaimer.legal' | translate"></p>
    <button class="chat-disclaimer-modal__btn" type="button" (click)="onDisclaimerAccept()">
      {{ 'chatAi.disclaimer.accept' | translate }}
    </button>
  </div>
</div>

<div class="chat-page" [class.sidebar-is-open]="sidebarOpen">

  <!-- Mobile backdrop — closes drawer on tap -->
  <div class="chat-page__backdrop" *ngIf="sidebarOpen" (click)="closeSidebar()"></div>

  <app-chat-sidebar
    [conversations]="conversations"
    [activeId]="activeId"
    [agents]="agents"
    (pick)="onPick($event); closeSidebar()"
    (newChat)="onNewChat(); closeSidebar()"
    (rename)="onRename($event)"
    (deleteChat)="onDeleteChat($event)"
    (tabChange)="$event === 'agents' ? onShowAgentDirectory() : onShowChat()">
  </app-chat-sidebar>

  <!-- Hamburger fixed — mobile only, always on top-left -->
  <button type="button" class="chat-page__hamburger" (click)="toggleSidebar()"
          aria-label="Abrir menú de conversaciones">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
      <line x1="3" y1="6" x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  </button>

  <!-- ═══ MAIN AREA ═══════════════════════════════════════════════ -->
  <section class="chat-page__main" [attr.aria-label]="'chatAi.page.ariaLabel' | translate">

    <!-- ── AI Act persistent disclaimer banner ── -->
    <div class="chat-page__ai-banner" role="note" [attr.aria-label]="'chatAi.disclaimer.bannerAria' | translate">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ 'chatAi.banner' | translate }}
    </div>

    <!-- ══ VIEW 1: Agent Directory (when Agentes tab is active + no agent selected) ══ -->
    <div class="chat-page__agent-hub" *ngIf="showAgentDirectory">
      <div class="chat-page__agent-hub-header">
        <h2>{{ 'chatAi.agentHub.title' | translate }}</h2>
        <p>{{ 'chatAi.agentHub.subtitle' | translate }}</p>
      </div>
      <div class="chat-page__agent-grid">
        <div *ngFor="let agent of agents"
             class="chat-page__agent-big-card"
             [class.locked]="agent.status === 'locked'"
             [style.border-top-color]="agent.accentColor">
          <span class="chat-page__agent-big-icon">{{ agent.icon }}</span>
          <div class="chat-page__agent-big-info">
            <span class="chat-page__agent-big-code">{{ agent.code }}</span>
            <span class="chat-page__agent-big-name">{{ agent.nameKey | translate }}</span>
            <p class="chat-page__agent-big-desc">{{ agent.descriptionKey | translate }}</p>
          </div>
          <span *ngIf="agent.status !== 'locked'"
                class="chat-page__agent-big-available"
                [style.color]="agent.accentColor"
                [style.border-color]="agent.accentColor + '40'">
            {{ 'chatAi.agentHub.availableInChat' | translate }}
          </span>
          <span *ngIf="agent.status === 'locked'" class="chat-page__agent-big-locked">
            {{ 'chatAi.agentHub.locked' | translate }}
          </span>
        </div>
      </div>
    </div>

    <!-- ══ VIEW 2: Chat (CAFI general or agent conversation) ══ -->
    <ng-container *ngIf="!showAgentDirectory">

      <!-- Toolbar -->
      <div class="chat-page__toolbar" *ngIf="messages.length > 0">
        <!-- Active agent badge (shown while streaming) -->
        <span *ngIf="(activeAgentCode$ | async) as agentCode"
              class="chat-page__agent-badge"
              [style.color]="getAgentColor(agentCode)"
              [style.border-color]="getAgentColor(agentCode) + '40'">
          {{ getAgentIcon(agentCode) }} {{ agentCode }}
        </span>

        <button type="button" class="chat-page__reset-btn" (click)="onNewChat()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
            <path d="M3 3v5h5"/>
          </svg>
          {{ 'chatAi.drawer.resetContext' | translate }}
        </button>

        <button type="button" class="chat-page__export-btn" (click)="onExportPdf()"
                title="Exportar a PDF" aria-label="Exportar conversación a PDF">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          PDF
        </button>
      </div>

      <!-- Hero — CAFI greeting -->
      <header class="chat-page__hero" *ngIf="messages.length === 0">
        <div class="chat-page__greeting">
          <img src="assets/cafler-avatar.svg" alt="" class="chat-page__greeting-avatar" />
          <h3>{{ userName ? ('chatAi.page.greeting.titleWithName' | translate:{ name: userName }) : ('chatAi.page.greeting.title' | translate) }}</h3>
          <p>{{ 'chatAi.page.greeting.subtitle' | translate }}</p>
        </div>
        <div class="chat-page__quick-cards">
          <button class="chat-page__card" (click)="onSuggestionPickI18n('chatAi.page.quickCards.daySummary.prompt')">
            <span class="chat-page__card-icon">📋</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.daySummary.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.daySummary.desc' | translate }}</span>
          </button>
          <button class="chat-page__card" (click)="onSuggestionPickI18n('chatAi.page.quickCards.kpis.prompt')">
            <span class="chat-page__card-icon">📊</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.kpis.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.kpis.desc' | translate }}</span>
          </button>
          <button class="chat-page__card" (click)="onSuggestionPickI18n('chatAi.page.quickCards.stuckVehicles.prompt')">
            <span class="chat-page__card-icon">🚗</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.stuckVehicles.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.stuckVehicles.desc' | translate }}</span>
          </button>
          <button class="chat-page__card" (click)="onSuggestionPickI18n('chatAi.page.quickCards.criticalStock.prompt')">
            <span class="chat-page__card-icon">📦</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.criticalStock.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.criticalStock.desc' | translate }}</span>
          </button>
          <button class="chat-page__card" (click)="onSuggestionPickI18n('chatAi.page.quickCards.pendingBudgets.prompt')">
            <span class="chat-page__card-icon">💰</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.pendingBudgets.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.pendingBudgets.desc' | translate }}</span>
          </button>
          <button class="chat-page__card" (click)="onSuggestionPickI18n('chatAi.page.quickCards.monthClose.prompt')">
            <span class="chat-page__card-icon">📈</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.monthClose.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.monthClose.desc' | translate }}</span>
          </button>
          <button class="chat-page__card chat-page__card--agent" (click)="onSuggestionPickI18n('chatAi.page.quickCards.cashMargin.prompt')">
            <span class="chat-page__card-icon">💹</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.cashMargin.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.cashMargin.desc' | translate }}</span>
          </button>
          <button class="chat-page__card chat-page__card--agent" (click)="onSuggestionPickI18n('chatAi.page.quickCards.onboGetStarted.prompt')">
            <span class="chat-page__card-icon">🎓</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.onboGetStarted.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.onboGetStarted.desc' | translate }}</span>
          </button>
          <button class="chat-page__card chat-page__card--agent" (click)="onSuggestionPickI18n('chatAi.page.quickCards.onboStock.prompt')">
            <span class="chat-page__card-icon">📦</span>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.onboStock.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.onboStock.desc' | translate }}</span>
          </button>
          <button class="chat-page__card chat-page__card--nav" (click)="onNavigate('/calendar')">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.agenda.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.agenda.desc' | translate }}</span>
          </button>
          <button class="chat-page__card chat-page__card--nav" (click)="onNavigate('/kanban')">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="3" y="3" width="5" height="18" rx="1"/>
              <rect x="10" y="3" width="5" height="12" rx="1"/>
              <rect x="17" y="3" width="5" height="15" rx="1"/>
            </svg>
            <span class="chat-page__card-title">{{ 'chatAi.page.quickCards.kanban.title' | translate }}</span>
            <span class="chat-page__card-desc">{{ 'chatAi.page.quickCards.kanban.desc' | translate }}</span>
          </button>
        </div>
      </header>

      <app-chat-conversation *ngIf="messages.length > 0" [messages]="messages"
                             (suggestionPick)="onSuggestionPick($event)"
                             (retry)="onRetry($event)"></app-chat-conversation>

      <app-chat-input [busy]="busy" (send)="onSend($event)" (cancelRequest)="onCancel()"></app-chat-input>
    </ng-container>
  </section>
</div>
